import { motion } from "framer-motion";
import { SectionHeader } from "@/components/SectionHeader";
import { equipmentImages, images, siteImages } from "@/data/site";

const projects = [
  { title: "Crane Operations", image: equipmentImages.crawlerCrane, alt: "Crawler crane lifting steel at a refinery construction site", tag: "Cranes" },
  { title: "Access at Height", image: equipmentImages.straightBoomManlift, alt: "Boom manlift raised beside industrial steel structure", tag: "Manlifts" },
  { title: "Earthmoving Works", image: equipmentImages.excavator, alt: "Excavator digging earth at a large construction site", tag: "Excavators" },
  { title: "Active Project Sites", image: siteImages.constructionSite, alt: "Large construction site with tower cranes and workers", tag: "Construction Sites" },
  { title: "Refinery Environments", image: siteImages.refinery, alt: "Refinery plant with engineers walking in safety gear", tag: "Refinery" },
  { title: "Skilled Manpower", image: images.manpower, alt: "Industrial engineers at a refinery", tag: "Workforce" },
  { title: "Equipment Deployment", image: equipmentImages.trailer, alt: "Low-bed trailer transporting construction machinery", tag: "Mobilization" },
];

export function ProjectGallery() {
  return (
    <section id="gallery" className="border-b border-industrial-line py-24 sm:py-32" data-testid="project-gallery-section">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <SectionHeader eyebrow="Project Gallery / 07" title="Built for demanding project environments" description="Representative industrial environments are shown while company-owned deployment photography is being curated for this gallery." testId="project-gallery-header" />
        <div className="flex snap-x gap-6 overflow-x-auto pb-4" data-testid="project-gallery-scroller">
          {projects.map((project, index) => (
            <motion.article key={project.title} initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: Math.min(index * 0.08, 0.4) }} className="group min-w-[82%] snap-start border border-industrial-line bg-industrial-surface sm:min-w-[48%] lg:min-w-[31.5%]" data-testid={`project-gallery-card-${index + 1}`}>
              <div className="spotlight-image relative h-72 overflow-hidden border-b border-industrial-line">
                <img src={project.image} alt={project.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
              </div>
              <div className="p-6">
                <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-industrial-yellow">{project.tag} · Representative</p>
                <h3 className="mt-3 font-heading text-2xl font-semibold uppercase text-industrial-text">{project.title}</h3>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
